import { createSelector } from 'reselect';
import { stages } from 'Constants/stages';
import { StateType } from 'Types/common';
import { UserStateType } from './reducer';

export const userStageSelector = (state: StateType<UserStateType>): string | null =>
  state?.validations?.stage;

export const readOnlySelector = createSelector(
  userStageSelector,
  stage => stage === stages.RESULT || stage === stages.SUBMITTED
);
export const isLoadingDataSelector = (state: StateType<UserStateType>): boolean =>
  state.validations?.isLoading;
